<rx-intuitive-teeth-orchestrator-layout [hideSidebar]="true">
	<rx-intuitive-treatment-toolbar
		rx-intuitive-teeth-diagram-toolbar
		[showCopyFromToothMenu]="false"
		[currentOrchestratorViewMode]="orchestratorViewMode$ | async"
		[tableViewDisabled]="(isTableViewDisabled$ | async) ?? true"
		(viewModeSwitched)="changeOrchestratorViewMode($event)"
	/>

	<rx-intuitive-treatment-table rx-intuitive-teeth-diagram-diagram />
</rx-intuitive-teeth-orchestrator-layout>
